import { render, staticRenderFns } from "./AvsTabs.vue?vue&type=template&id=278c8e8e"
import script from "./AvsTabs.vue?vue&type=script&lang=js"
export * from "./AvsTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports